import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface PharmacyStoreProps extends CacheProps {
  clientContactId: string
  clientSuggestedType: string
  clientSuggestedTime?: string | undefined
  clientSuggestedRange?: string | undefined
  gender: string
  applicantName?: string
  applicantLastName?: string
  applicantCode?: string
  list?: string
  file?: any
  description?: string
  contributors: any
  hashedPharmacyId: string
  electronicPrescription?: any
}

const pharmacyStoreDataApi = ({ hashedPharmacyId, file, description, list, applicantLastName, applicantCode, applicantName, gender, contributors, clientSuggestedRange, clientSuggestedType, clientSuggestedTime, clientContactId, electronicPrescription, ...rest }: PharmacyStoreProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.pharmacies.store'],
    payload: {
      user_id: hashedPharmacyId,
      client_contact_id: clientContactId,
      client_suggested_type: clientSuggestedType,
      client_suggested_time: clientSuggestedTime,
      client_suggested_range: clientSuggestedRange,
      receiver: contributors['1'] || `${applicantName} ${applicantLastName}`,
      client: {
        choose_client: '1',
        first_name: applicantName,
        last_name: applicantLastName,
        national_id: applicantCode,
        sex: gender,
      },
      otc_base: list,
      files: file,
      description: description,
      prescription: electronicPrescription,
    },
    withToken: true,
    ...rest,
  });
};

export default pharmacyStoreDataApi;
